import { makeStyles } from '@mui/styles';
import { COLOR_GRAY_90, COLOR_WHITE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  // outerWrapper: {
  //   padding: '100px 20px 0',
  //   maxWidth: 1088,
  //   margin: '0 auto',
  //   backgroundColor: COLOR_WHITE,

  //   [theme.breakpoints.up('md')]: {
  //     paddingLeft: 40,
  //     paddingRight: 40,
  //     maxWidth: 1168,
  //   },
  //   [theme.breakpoints.up('lg')]: {
  //     paddingLeft: 0,
  //     paddingRight: 0,
  //     maxWidth: 1088,
  //   },
  // },
  testimonialCarousel: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
    backgroundColor: '#F2F5FF',
  },
  testimonialContainer: {
    position: 'relative',
    width: '100%',
    overflow: 'hidden',
    fontFamily: 'Lato',
  },
  titleSection: {
    textAlign: 'center',
    marginBottom: '2rem',
    display: 'flex',
    color: COLOR_GRAY_90,
    fontSize: 30,
    lineHeight: '34px',
    fontWeight: 700,
    // marginLeft: '121px',
  },
  carouselContainer: {
    display: 'flex',
    transition: 'transform 1s ease-in-out',
    animation: '$testimonialCarousal 30s linear infinite',
    animationPlayState: 'running',
    '&:hover': {
      animationPlayState: 'paused',
    },
    // marginLeft: '121px',
  },
  testimonialCard: {
    minWidth: '100%',
    padding: 20,
    boxSizing: 'border-box',
    backgroundColor: COLOR_WHITE,
    borderRadius: '20px',
    // boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
    margin: '0 10px',
    border: '1px solid #DCE1F0',
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      minWidth: '345px',
    },
  },
  testimonialData: {
    fontSize: 16,
    lineHeight: '30px',
    fontWeight: 400,
  },
  author: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '28px',
    color: '#616161',
  },
  avatar: {
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    marginRight: '8px',
  },
  dots: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '1rem',
  },
  active: {
    backgroundColor: theme.palette.primary.main,
  },
  logoCards: {
    display: 'flex',
    animation: '$logoCarousal 20s linear infinite',
    marginTop: '3rem',
    animationPlayState: 'running',
    gap: '70px',
    '&:hover': {
      animationPlayState: 'paused',
    },
  },
  logo: {
    // minWidth: '120px',
    // padding: '1rem',
    // display: 'flex',
    // justifyContent: 'center',
    // alignItems: 'center',
  },

  '@keyframes testimonialCarousal': {
    '0%': {
      transform: 'translateX(10%)',
    },
    '100%': {
      transform: 'translateX(-2550px)',
    },
  },

  '@keyframes logoCarousal': {
    '0%': {
      transform: 'translateX(10%)',
    },
    '100%': {
      transform: 'translateX(-1090px)',
    },
  },

  [theme.breakpoints.down('sm')]: {
    carouselContainer: {
      animation: 'none',
    },
  },
  socialLink: {
    textDecoration: 'none',
    color: '#616161',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));
